var exports = {
  "kL": "DMSidebarSkeleton.module__container___M3JsZU",
  "Kd": "DMSidebarSkeleton.module__containerMobile___M3JsZU",
  "wx": "DMSidebarSkeleton.module__header___M3JsZU",
  "Od": "DMSidebarSkeleton.module__mobileHeader___M3JsZU",
  "Fy": "DMSidebarSkeleton.module__mobileHeaderActions___M3JsZU",
  "P1": "DMSidebarSkeleton.module__scrollArea___M3JsZU",
  "Qs": "DMSidebarSkeleton.module__content___M3JsZU",
  "wh": "DMSidebarSkeleton.module__mobileContent___M3JsZU",
  "jH": "DMSidebarSkeleton.module__spacer___M3JsZU",
  "nM": "DMSidebarSkeleton.module__row___M3JsZU",
  "TZ": "DMSidebarSkeleton.module__mobileRow___M3JsZU",
  "u4": "DMSidebarSkeleton.module__rowContent___M3JsZU",
  "yW": "DMSidebarSkeleton.module__channelInfo___M3JsZU",
  "jn": "DMSidebarSkeleton.module__channelNameRow___M3JsZU",
  "$s": "DMSidebarSkeleton.module__channelSubtextRow___M3JsZU",
  "me": "DMSidebarSkeleton.module__separator___M3JsZU",
  "bV": "DMSidebarSkeleton.module__sectionHeader___M3JsZU",
  "o5": "DMSidebarSkeleton.module__channelList___M3JsZU",
  "US": "DMSidebarSkeleton.module__bottomSpacer___M3JsZU",
  "cB": "DMSidebarSkeleton.module__mobileFab___M3JsZU",
};

module.exports = exports;
